import { inject, Injectable } from '@angular/core';
import {Subject} from "rxjs";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  protected translate = inject(TranslateService)

  public statusUpdated: Subject<string> = new Subject<string>();
  constructor() { }

  public clearStatus(){
    this.statusUpdated.next("");
  }

  public setStatus(status: string){
    this.statusUpdated.next(status);
  }

  public setLoadedItems(count: number ){
    this.statusUpdated.next(this.translate.instant("INFO.ITEMSLOADED",{'value': count}));
  }
}
